import React from "react";
import { Link } from "react-router-dom";
import ComingSoonIntegration from "./ComingSoonIntegration";
import { INTEGRATIONS_HUB } from "./paths";

const JiraIntegration: React.FC = () => (
  <ComingSoonIntegration
    name="Jira"
    logo="J"
    logoBg="#2684ff"
    connectLabel="Connect Jira"
    subtitle="Let agents search issues, projects, and comments. This is a tool integration — not a data source. Connect will use OAuth; secrets never go in Agent Builder chat."
    whatAgentsDo={
      <>
        After connect, associated agents can look up Jira issues and summarise
        project activity in a bounded actions loop (same associate → describe →
        execute pattern as data sources). Retrieval indexes stay on{" "}
        <Link to={`${INTEGRATIONS_HUB}?category=data_source`}>
          Data sources
        </Link>
        .
      </>
    }
  />
);

export default JiraIntegration;
